import { render, staticRenderFns } from "./upload-ext-cost.vue?vue&type=template&id=c21c7c70&scoped=true"
import script from "./upload-ext-cost.vue?vue&type=script&lang=js"
export * from "./upload-ext-cost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21c7c70",
  null
  
)

export default component.exports